<template>
  <div class="btn btn-mfd" :class="{ 'btn-mfd-outline': outline }">
    <slot></slot>
  </div>
</template>

<script>
export default {
  props: {
    outline: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style lang="scss" scoped>
.btn-mfd {
  background: linear-gradient(135deg, $color-pink-dark 0%, darken($color-pink-dark, 10%) 100%);
  color: #fff;
  border-radius: 25px;
  padding: 12px 24px;
  font-size: 14px;
  font-weight: 600;
  border: none;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  box-shadow: 0 4px 15px rgba(255, 192, 203, 0.3);
  text-transform: uppercase;
  letter-spacing: 0.5px;
  min-width: 120px;
  text-align: center;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  transform: translateY(0);
  
  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: -100%;
    width: 100%;
    height: 100%;
    background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.2), transparent);
    transition: left 0.5s;
  }

  &::after {
    content: '';
    position: absolute;
    top: 50%;
    left: 50%;
    width: 0;
    height: 0;
    background: rgba(255, 255, 255, 0.1);
    border-radius: 50%;
    transform: translate(-50%, -50%);
    transition: width 0.3s, height 0.3s;
  }

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 8px 25px rgba(255, 192, 203, 0.4);
    background: linear-gradient(135deg, lighten($color-pink-dark, 5%) 0%, $color-pink-dark 100%);
    
    &::before {
      left: 100%;
    }
    
    &::after {
      width: 300px;
      height: 300px;
    }
  }

  &:active {
    transform: translateY(0);
    box-shadow: 0 2px 10px rgba(255, 192, 203, 0.3);
  }
}

.btn-mfd-outline {
  background: transparent;
  color: $color-pink-dark;
  border: 2px solid $color-pink-dark;
  box-shadow: 0 4px 15px rgba(255, 192, 203, 0.1);
  
  &::before {
    background: linear-gradient(90deg, transparent, rgba(255, 192, 203, 0.1), transparent);
  }

  &:hover {
    background: linear-gradient(135deg, $color-pink-dark 0%, darken($color-pink-dark, 5%) 100%);
    color: white;
    border-color: $color-pink-dark;
    box-shadow: 0 8px 25px rgba(255, 192, 203, 0.3);
    
    &::before {
      background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.2), transparent);
    }
  }
}
</style>
